module.exports = __webpack_public_path__ + "media/images/vgood_smiley_selected-de8fa6da9a3fa9aa878dd788cbc89213.svg";